// Cookies
export const MISCGCS = 'MISCGCs';
export const FORWARDPAGE_KEY = 'FORWARDPAGE_KEY';
export const SHIPPING_COUNTRY = 'shippingCountry';
export const CURRENCY = 'currency';
export const USER_ENCODED_EMAIL = 'u_e_e';
export const SIGNEDIN = 'SignedIn';
export const USER_POSTAL_CODE = 'USERPC';
export const USER_STATE = 'USERST';
export const USER_DESIGNATED_MARKET_AREA = 'USERDMA';
export const MACYS_ONLINE_UID = 'macys_online_uid';
export const MACYS_ONLINE_GUID = 'macys_online_guid';
export const MACYS_BAGID = 'macys_bagid';

// LocalStorage
export const RVI_STORAGE_NAME = 'recentlyViewedItems';
